import React, { Component } from "react";
import { connect } from "react-redux";
import { setGdpr } from "../../../../../redux/notificationsSlice";

class Notifications extends Component {
  render() {
    const notifications = this.props.notifications.notifications;

    if (notifications.length > 0) {
      return (
        <div id="notifications">
          {notifications.map((notification, index) => {
            return (
              <div key={index} className="notification">
                <div className={`ui message compact ${notification.type}`}>
                  <span className="title">{notification.type}</span>
                  <span>{notification.text}</span>
                </div>
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications,
});

const mapDispatchToProps = (dispatch) => ({
  setGdpr: (gdpr) => dispatch(setGdpr(gdpr)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
